import bush from './assets/life-skills/berry-bush-eo-v2.png';
import oak from './assets/life-skills/oak-tree-eo-v2.png';
import fish from './assets/life-skills/fishing-spot-eo-v2.png';
import fire from './assets/life-skills/campfire-eo-v2.png';
import fishingNetAction from './assets/life-skills/fishing-net-action.svg';
import cookedFishIcon from './assets/life-skills/cooked-fish-icon.png';
import logsInventory from './assets/life-skills/items/logs/inventory.png';
import logsTrade from './assets/life-skills/items/logs/trade.png';
import logsFloor from './assets/life-skills/items/logs/floor.png';
import berriesInventory from './assets/life-skills/items/berries/inventory.png';
import berriesTrade from './assets/life-skills/items/berries/trade.png';
import berriesFloor from './assets/life-skills/items/berries/floor.png';
import netInventory from './assets/life-skills/items/fishing-net/inventory.png';
import netTrade from './assets/life-skills/items/fishing-net/trade.png';
import netFloor from './assets/life-skills/items/fishing-net/floor.png';

export type LifeArt = {url:string;frames:number;frame:number;width:number;height:number;alignFrames?:boolean;fixedCanvas?:boolean};
// One source of sizing for resource UI and the upcoming world renderer.
export const lifeResourceArt: Readonly<Record<string, LifeArt>> = {
  cooked_fish:{url:cookedFishIcon,frames:1,frame:0,width:32,height:32,fixedCanvas:true},
  campfire:{url:fire,frames:4,frame:0,width:32,height:32},
  berry_bush:{url:bush,frames:2,frame:0,width:96,height:64},
  berry_bush_empty:{url:bush,frames:2,frame:1,width:96,height:64},
  oak:{url:oak,frames:2,frame:0,width:96,height:160,alignFrames:true},
  stump:{url:oak,frames:2,frame:1,width:96,height:160,alignFrames:true},
  fishing_spot:{url:fish,frames:4,frame:0,width:48,height:24},
  fishing_spot_empty:{url:fish,frames:4,frame:0,width:48,height:24},
  fishing_net_action:{url:fishingNetAction,frames:4,frame:0,width:48,height:32,fixedCanvas:true},
};
export const lifeItemArt = {
  oak_logs:{inventory:logsInventory,trade:logsTrade,floor:logsFloor},
  berries:{inventory:berriesInventory,trade:berriesTrade,floor:berriesFloor},
  fishing_net:{inventory:netInventory,trade:netTrade,floor:netFloor},
} as const;

const loaded = new Map<string, Promise<HTMLCanvasElement>>();
/** Animated sheets keep a stable canvas; tree states share scale and ground anchor. */
export function loadLifeArt(art:LifeArt):Promise<HTMLCanvasElement>{
  const key=JSON.stringify(art);const cached=loaded.get(key);if(cached)return cached;
  const promise=new Promise<HTMLCanvasElement>((resolve,reject)=>{
    const image=new Image();image.onerror=()=>reject(new Error('Life skill art unavailable'));
    image.onload=()=>{try{
      const source=document.createElement('canvas');source.width=image.width;source.height=image.height;
      const ctx=source.getContext('2d')!;ctx.drawImage(image,0,0);
      const pixels=ctx.getImageData(0,0,source.width,source.height).data;
      const fw=Math.floor(image.width/art.frames);let left=fw,top=image.height,right=-1,bottom=-1;
      const bounds=Array.from({length:art.frames},()=>({left:fw,top:image.height,right:-1,bottom:-1}));
      for(let f=0;f<art.frames;f++)for(let y=0;y<image.height;y++)for(let x=0;x<fw;x++){
        if(pixels[(y*image.width+f*fw+x)*4+3]>32){left=Math.min(left,x);top=Math.min(top,y);right=Math.max(right,x);bottom=Math.max(bottom,y);
          const b=bounds[f];b.left=Math.min(b.left,x);b.top=Math.min(b.top,y);b.right=Math.max(b.right,x);b.bottom=Math.max(b.bottom,y);}
      }
      if(right<left)throw new Error('Empty life skill art');
      const output=document.createElement('canvas');output.width=art.width;output.height=art.height;
      const dest=output.getContext('2d')!;dest.imageSmoothingEnabled=false;
      if(art.fixedCanvas){
        dest.drawImage(image,art.frame*fw,0,fw,image.height,0,0,art.width,art.height);
      }else if(art.alignFrames){
        const maxW=Math.max(...bounds.map(b=>b.right-b.left+1)),maxH=Math.max(...bounds.map(b=>b.bottom-b.top+1));
        const scale=Math.min(art.width/maxW,art.height/maxH),b=bounds[art.frame];
        const w=Math.round((b.right-b.left+1)*scale),h=Math.round((b.bottom-b.top+1)*scale);
        dest.drawImage(image,art.frame*fw+b.left,b.top,b.right-b.left+1,b.bottom-b.top+1,Math.round((art.width-w)/2),art.height-h,w,h);
      }else{
        dest.drawImage(image,art.frame*fw+left,top,right-left+1,bottom-top+1,0,0,art.width,art.height);
      }
      resolve(output);
    }catch(error){reject(error);}};image.src=art.url;
  });
  loaded.set(key,promise);void promise.catch(()=>loaded.delete(key));return promise;
}
